var _rect, _g, _rect2, _path, _path2, _path3, _path4, _path5, _rect3, _rect4, _rect5, _g2, _rect6, _rect7, _g3, _rect8, _circle, _circle2, _circle3, _rect9, _circle4, _circle5, _circle6, _rect10, _circle7, _circle8, _circle9, _g4, _g5, _g6, _g7, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandingTimeline2Image(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220 409.995C324.934 409.995 410 324.93 410 219.997C410 115.065 324.934 30 220 30C115.066 30 30 115.065 30 219.997C30 324.93 115.066 409.995 220 409.995Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.002 410C291.727 410 349.871 324.935 349.871 220.003C349.871 115.07 291.727 30.0054 220.002 30.0054C148.278 30.0054 90.1335 115.07 90.1335 220.003C90.1335 324.935 148.278 410 220.002 410Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.002 410C242.185 410 260.168 324.935 260.168 220.003C260.168 115.07 242.185 30.0054 220.002 30.0054C197.82 30.0054 179.837 115.07 179.837 220.003C179.837 324.935 197.82 410 220.002 410Z",
    stroke: "#838383",
    strokeMiterlimit: 10
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 225.5,
    y: 140.504,
    width: 199,
    height: 199,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M271.265 277.377C270.135 275.783 269.084 274.11 268.044 272.391C262.089 262.077 258.955 250.377 258.957 238.467C258.958 226.558 262.096 214.859 268.054 204.546C274.013 194.234 282.581 185.673 292.898 179.723C303.215 173.773 314.916 170.645 326.826 170.652V238.478L271.265 277.377Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.111 285.708C375.865 294.333 366.734 301.178 356.422 305.712C346.11 310.246 334.894 312.348 323.64 311.857C312.386 311.365 301.395 308.292 291.518 302.876C281.641 297.46 273.141 289.846 266.676 280.621L326.826 238.478L383.111 285.708Z",
    fill: "white",
    stroke: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.669 207.391C387.047 218.441 389.872 231.185 388.76 243.895C387.648 256.605 382.652 268.665 374.451 278.439L326.826 238.478L380.669 207.391Z",
    fill: "white",
    stroke: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M359.996 163.338C366.454 165.064 372.509 168.046 377.814 172.114C383.119 176.181 387.57 181.255 390.913 187.043L346.826 212.478L359.996 163.338Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M326.826 165C333.246 164.999 339.638 165.838 345.84 167.498L326.826 238.478V165Z",
    fill: "#BEBEBE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 265.5,
    y: 356.5,
    width: 59,
    height: 31,
    rx: 15.5,
    fill: "#252525",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 296.5,
    y: 359.5,
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white",
    stroke: "#252525"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 100.504,
    width: 199,
    height: 119,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_703)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8908 124H48V196H57.8908V124Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.8908 167.924H48V196H57.8908V167.924Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 172.797V196H57.8908V172.797H48Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 172.797V196H57.8908V172.797H48Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.378 124H146.487V196H156.378V124Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.487 179.168V196.022H156.378V179.168H146.487Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5127 124H72.6218V196H82.5127V124Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.5518 145.996L72.5518 196.022H82.4426L82.4426 145.996H72.5518Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6218 172.775V196H82.5126V172.775H72.6218Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5127 153.998H72.6218V196H82.5127V153.998Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6218 172.775V196H82.5126V172.775H72.6218Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.134 124H97.2437V196H107.134V124Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.1736 150.556L97.1736 196.022H107.064L107.064 150.556H97.1736Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2437 172.775V196H107.134V172.775H97.2437Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.134 153.998H97.2437V196.022H107.134V153.998Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2437 172.775V196H107.134V172.775H97.2437Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.756 124H121.865V196H131.756V124Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.865 140.72L121.865 196H131.756V140.72H121.865Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.756 153.998H121.865V196H131.756V153.998Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.865 172.775V196H131.756V172.775H121.865Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.865 172.775V196H131.756V172.775H121.865Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181 124H171.109V196H181V124Z",
    fill: "#252525"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.109 140.72V196H181V140.72H171.109Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 153.998H171.109V196H181V153.998Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.109 172.775V196H181V172.775H171.109Z",
    fill: "#141414"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 265.5,
    width: 199,
    height: 119,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_243_703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 265,
    width: 160,
    height: 120
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 265.5,
    width: 159,
    height: 119,
    rx: 4.5,
    fill: "white",
    stroke: "#252525"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_243_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.61171 359.922C-9.23513 359.922 -9.8437 359.922 -10.4671 359.833C-13.6935 359.541 -16.7828 358.39 -19.4139 356.5C-22.0451 354.61 -24.1222 352.05 -25.4292 349.086L-45.72 303.948L-44.3692 303.339L-24.1378 348.478C-22.9198 351.192 -21.0059 353.536 -18.5901 355.273C-16.1742 357.009 -13.3423 358.076 -10.3812 358.365C-7.4201 358.655 -4.43516 358.156 -1.72886 356.92C0.97744 355.684 3.30891 353.755 5.02928 351.328L29.8028 316.431C31.367 314.229 33.3977 312.4 35.75 311.073C38.1024 309.746 40.7185 308.954 43.4119 308.755C46.1053 308.555 48.8096 308.951 51.332 309.917C53.8545 310.882 56.1329 312.391 58.005 314.338L82.1699 339.453C83.8436 341.19 85.8698 342.548 88.1121 343.436C90.3545 344.324 92.7611 344.722 95.17 344.602C97.579 344.483 99.9344 343.849 102.078 342.743C104.221 341.637 106.103 340.085 107.597 338.191L128.036 312.26C129.888 309.912 132.286 308.052 135.021 306.841C137.756 305.63 140.745 305.105 143.729 305.311C146.712 305.517 149.601 306.448 152.143 308.024C154.685 309.6 156.804 311.772 158.316 314.353L168.499 331.749C169.89 334.128 171.844 336.13 174.187 337.58C176.531 339.029 179.195 339.883 181.945 340.066C184.695 340.249 187.448 339.756 189.963 338.63C192.478 337.503 194.68 335.778 196.374 333.605L200.827 327.979L202 328.899L197.547 334.525C195.699 336.886 193.303 338.759 190.566 339.982C187.829 341.205 184.834 341.74 181.843 341.541C178.852 341.342 175.955 340.414 173.404 338.84C170.853 337.265 168.726 335.091 167.207 332.506L157.025 315.095C155.634 312.723 153.684 310.727 151.346 309.281C149.007 307.834 146.351 306.981 143.607 306.795C140.864 306.609 138.117 307.096 135.605 308.214C133.093 309.332 130.892 311.047 129.194 313.21L108.769 339.111C107.144 341.172 105.096 342.861 102.763 344.064C100.431 345.268 97.8672 345.957 95.2457 346.086C92.6242 346.216 90.0054 345.782 87.5656 344.815C85.1258 343.847 82.9215 342.368 81.1012 340.477L56.9512 315.362C55.23 313.572 53.1348 312.183 50.8151 311.295C48.4955 310.408 46.0085 310.043 43.5317 310.228C41.0548 310.412 38.6492 311.141 36.4865 312.362C34.3237 313.583 32.4571 315.266 31.0199 317.292L6.23159 352.188C4.56214 354.577 2.34108 356.527 -0.243019 357.873C-2.82712 359.219 -5.69793 359.922 -8.61171 359.922Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9042 312.438C45.388 312.438 46.5908 311.235 46.5908 309.751C46.5908 308.268 45.388 307.065 43.9042 307.065C42.4204 307.065 41.2175 308.268 41.2175 309.751C41.2175 311.235 42.4204 312.438 43.9042 312.438Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0839 348.552C96.5676 348.552 97.7705 347.349 97.7705 345.865C97.7705 344.381 96.5676 343.179 95.0839 343.179C93.6001 343.179 92.3972 344.381 92.3972 345.865C92.3972 347.349 93.6001 348.552 95.0839 348.552Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.835 309.009C144.318 309.009 145.521 307.807 145.521 306.323C145.521 304.839 144.318 303.636 142.835 303.636C141.351 303.636 140.148 304.839 140.148 306.323C140.148 307.807 141.351 309.009 142.835 309.009Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.589 340.477C184.589 339.943 184.431 339.421 184.134 338.976C183.837 338.532 183.415 338.186 182.921 337.981C182.428 337.777 181.885 337.723 181.36 337.828C180.836 337.932 180.355 338.189 179.977 338.567C179.599 338.945 179.342 339.426 179.238 339.95C179.134 340.474 179.187 341.017 179.392 341.511C179.596 342.005 179.942 342.427 180.387 342.723C180.831 343.02 181.353 343.179 181.888 343.179C182.604 343.179 183.291 342.894 183.798 342.387C184.304 341.881 184.589 341.194 184.589 340.477Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.638 344.737H167.089C165.508 344.65 163.977 344.151 162.649 343.289C161.321 342.427 160.242 341.233 159.519 339.824L153.255 327.727C152.635 326.519 151.702 325.5 150.552 324.776C149.403 324.053 148.081 323.652 146.724 323.615C145.362 323.545 144.007 323.851 142.807 324.501C141.608 325.15 140.611 326.117 139.925 327.296C139.061 328.726 137.821 329.891 136.34 330.665C134.86 331.438 133.195 331.791 131.528 331.683C129.861 331.576 128.255 331.014 126.885 330.057C125.516 329.1 124.435 327.786 123.761 326.257L114.588 305.595C113.57 303.287 111.939 301.302 109.873 299.855C107.806 298.407 105.383 297.553 102.866 297.385C100.349 297.217 97.8336 297.741 95.5931 298.9C93.3526 300.06 91.4722 301.811 90.1558 303.963L68.1877 339.928C67.5112 341.031 66.608 341.977 65.5379 342.705C64.4678 343.432 63.2554 343.924 61.9809 344.147C60.7065 344.37 59.3992 344.32 58.1457 343.999C56.8921 343.679 55.721 343.096 54.71 342.288L25.7359 319.147C24.3311 318.018 22.5711 317.423 20.7691 317.469C18.967 317.516 17.2398 318.2 15.8948 319.4L-8.04749 340.566C-9.25507 341.633 -10.7226 342.362 -12.3019 342.679C-13.8812 342.997 -15.5164 342.893 -17.0425 342.377L-56.1101 329.137L-55.6351 327.727L-16.5675 340.982C-15.2936 341.419 -13.9267 341.513 -12.6051 341.252C-11.2836 340.991 -10.0544 340.386 -9.04199 339.498L14.9003 318.272C16.5102 316.838 18.5762 316.022 20.7313 315.967C22.8863 315.913 24.9908 316.624 26.671 317.975L55.6303 341.101C56.4779 341.776 57.4592 342.264 58.5094 342.532C59.5596 342.8 60.6548 342.842 61.7225 342.656C62.7902 342.469 63.8061 342.058 64.7031 341.45C65.6001 340.841 66.3578 340.049 66.926 339.127L88.9387 303.176C90.3939 300.777 92.48 298.824 94.9695 297.53C97.459 296.235 100.256 295.65 103.056 295.836C105.855 296.023 108.55 296.976 110.845 298.589C113.141 300.203 114.949 302.416 116.072 304.987L125.201 325.649C125.764 326.929 126.668 328.03 127.814 328.831C128.96 329.632 130.305 330.103 131.7 330.192C133.096 330.281 134.489 329.984 135.728 329.335C136.966 328.685 138.002 327.708 138.723 326.51C139.564 325.123 140.759 323.985 142.185 323.213C143.611 322.44 145.217 322.061 146.838 322.114C148.459 322.167 150.037 322.65 151.41 323.514C152.783 324.377 153.901 325.591 154.65 327.029L160.914 339.127C161.525 340.29 162.426 341.275 163.529 341.989C164.632 342.702 165.9 343.12 167.212 343.2C168.523 343.281 169.833 343.022 171.015 342.449C172.198 341.876 173.212 341.007 173.961 339.928L200.679 300.267L201.911 301.098L175.178 340.715C174.354 341.958 173.233 342.977 171.916 343.679C170.6 344.381 169.13 344.745 167.638 344.737Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1908 345.865C63.6746 345.865 64.8774 344.662 64.8774 343.179C64.8774 341.695 63.6746 340.492 62.1908 340.492C60.707 340.492 59.5042 341.695 59.5042 343.179C59.5042 344.662 60.707 345.865 62.1908 345.865Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.437 299.287C102.921 299.287 104.124 298.084 104.124 296.6C104.124 295.117 102.921 293.914 101.437 293.914C99.9531 293.914 98.7502 295.117 98.7502 296.6C98.7502 298.084 99.9531 299.287 101.437 299.287Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.331 333.53C132.815 333.53 134.018 332.328 134.018 330.844C134.018 329.36 132.815 328.157 131.331 328.157C129.847 328.157 128.644 329.36 128.644 330.844C128.644 332.328 129.847 333.53 131.331 333.53Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.649 325.678C148.133 325.678 149.336 324.475 149.336 322.992C149.336 321.508 148.133 320.305 146.649 320.305C145.166 320.305 143.963 321.508 143.963 322.992C143.963 324.475 145.166 325.678 146.649 325.678Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.518 343.995C170.521 343.46 170.365 342.936 170.07 342.49C169.775 342.044 169.354 341.695 168.86 341.489C168.367 341.282 167.823 341.226 167.298 341.329C166.773 341.431 166.291 341.687 165.911 342.065C165.532 342.442 165.273 342.923 165.168 343.448C165.062 343.972 165.115 344.516 165.319 345.011C165.523 345.505 165.869 345.928 166.314 346.225C166.758 346.523 167.281 346.682 167.816 346.682C168.53 346.682 169.215 346.399 169.721 345.896C170.227 345.392 170.514 344.709 170.518 343.995Z",
    fill: "#252525"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 199,
    height: 29,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 15 94)",
    fill: "#252525",
    stroke: "#252525"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 80,
    r: 3,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 80,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 80,
    r: 3,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 199,
    height: 29,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 15 259)",
    fill: "#252525",
    stroke: "#252525"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 245,
    r: 3,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 245,
    r: 3,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 245,
    r: 3,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 199,
    height: 29,
    rx: 4.5,
    transform: "matrix(1 0 0 -1 225 134)",
    fill: "#252525",
    stroke: "#252525"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 120,
    r: 3,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 249,
    cy: 120,
    r: 3,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 259,
    cy: 120,
    r: 3,
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_243_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.009 70.3665H267.21",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61 87.967V52.7659",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.61 60.9387C249.098 63.1556 248.006 65.1964 246.445 66.8513C244.883 68.5062 242.91 69.7156 240.726 70.3553C240.726 70.3553 248.499 73.3313 249.665 80.4604C249.665 80.4604 251.498 70.3553 259.937 70.3553C259.882 70.3553 252.231 70.9438 249.61 60.9387Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_243_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.09 196.694H203.636",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.863 204.467V188.921",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.863 192.53C195.637 193.509 195.155 194.411 194.465 195.142C193.776 195.872 192.904 196.407 191.94 196.689C191.94 196.689 195.373 198.003 195.888 201.152C195.888 201.152 196.697 196.689 200.424 196.689C200.399 196.689 197.02 196.949 195.863 192.53Z",
    fill: "#252525"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_243_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.91 214.995H258.456",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.683 222.769V207.222",
    stroke: "#252525",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.683 210.832C250.457 211.811 249.975 212.712 249.285 213.443C248.596 214.174 247.724 214.708 246.76 214.991C246.76 214.991 250.193 216.305 250.708 219.453C250.708 219.453 251.517 214.991 255.244 214.991C255.22 214.991 251.841 215.25 250.683 210.832Z",
    fill: "#252525"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_243_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8149 235.581H26.3612",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5881 243.354V227.808",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5881 231.417C18.3622 232.396 17.8797 233.298 17.1902 234.028C16.5007 234.759 15.6291 235.293 14.6648 235.576C14.6648 235.576 18.0977 236.89 18.6127 240.039C18.6127 240.039 19.4218 235.576 23.149 235.576C23.1245 235.576 19.7455 235.836 18.5881 231.417Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M418.444 126.238H433.991",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M426.218 134.011V118.464",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M426.218 122.074C425.992 123.053 425.509 123.954 424.82 124.685C424.13 125.416 423.258 125.95 422.294 126.233C422.294 126.233 425.727 127.547 426.242 130.696C426.242 130.696 427.051 126.233 430.778 126.233C430.754 126.233 427.375 126.493 426.218 122.074Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M329.22 385.366H344",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M336.61 392.757V377.976",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M336.61 381.408C336.395 382.339 335.936 383.196 335.281 383.891C334.625 384.585 333.797 385.093 332.88 385.362C332.88 385.362 336.144 386.611 336.633 389.605C336.633 389.605 337.403 385.362 340.946 385.362C340.923 385.362 337.71 385.609 336.61 381.408Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 133,
    height: 72,
    fill: "white",
    transform: "translate(48 124)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_243_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.2011,
    height: 35.2011,
    fill: "white",
    transform: "translate(232.009 52.7659)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_243_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(188.09 188.921)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_243_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(242.91 207.222)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_243_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5462,
    height: 15.5462,
    fill: "white",
    transform: "translate(10.8149 227.808)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTimeline2Image);
export default __webpack_public_path__ + "static/media/landing-timeline-2-image.ef5d96c645e891e3eede5b1b5ba00604.svg";
export { ForwardRef as ReactComponent };